import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';

import { IconsFontAwesomeService } from '@blaze-shared/theming-data-access';
import { getIconStyleWithPrefix, IconMetadata } from '@blaze-shared/theming-domain';

@Injectable({
  providedIn: 'root',
})
export class IconResolverService {
  private readonly fontAwesomeService = inject(IconsFontAwesomeService);
  private icons: Record<string, IconMetadata> = {};
  private iconsLoaded = false;

  resolveFullIconName(iconName: string): string {
    const icon = this.icons[iconName];

    if (!icon) {
      return iconName;
    }

    return getIconStyleWithPrefix(iconName, icon.styles[0], icon.lib);
  }

  waitForIconsToLoad(): Observable<unknown> {
    if (this.iconsLoaded) {
      return of(undefined);
    }

    return this.loadIcons();
  }

  private loadIcons(): Observable<unknown> {
    return this.fontAwesomeService.getIcons().pipe(
      tap((icons) => {
        this.icons = icons;
        this.iconsLoaded = true;
      }),
      catchError(() => {
        this.icons = {};
        return of(this.icons);
      }),
    );
  }
}
